var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":"Landingpage löschen","action":"delete","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('div',{staticClass:"mb-2"},[_vm._v(" Soll die Landingpage "),_c('span',{staticClass:"font-semibold"},[_vm._v("\""+_vm._s(_vm.slug)+"\"")]),_vm._v(" wirklich gelöscht werden? ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }